import { Combobox, Option } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { Article } from "../../store/Data";
import { useEditorStyles } from "../Styles/Editor";

type ArticleDropdownProps = {
    setArticle: (article?: Article) => void;
    currentArticle?: Article;
};

export const ArticleDropdown: React.FC<ArticleDropdownProps> = ({ setArticle, currentArticle }) => {
    // Collection
    const articles = useSelector<ApplicationState, Article[] | undefined>((state: ApplicationState) => state.data.articles);
    // Filters
    const [Filter, setFilter] = React.useState<Article[]>([]);
    const [Search, setSearch] = React.useState<string | undefined>();
    // Other
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Initial load
    React.useEffect(() => {
        if (articles !== undefined) {
            setFilter(articles.filter(a => a.isActif));
        }
    }, [articles]);
    return <Combobox
        className={styles.fluid}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        freeform
        placeholder={t('SelectArticle')}
        onChange={(event) => {
            if (articles !== undefined) {
                const value = event.target.value.trim();
                const matches = articles.filter(
                    (c) => c.isActif && c.displayName !== null && c.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1
                );
                setFilter(matches);
                if (value.length && matches.length < 1) {
                    setSearch(value);
                    setArticle(undefined);
                } else if (value.length && matches.length === 1) {
                    setSearch(value);
                    setArticle(matches[0]);
                } else {
                    setSearch(undefined);
                    setArticle(undefined);
                }
            }
        }}
        onOptionSelect={(event, data) => {
            if (data.optionValue && articles) {
                const matchingOption = articles.find(c => c.articleid === data.optionValue);
                if (matchingOption) {
                    setSearch(undefined);
                    if (matchingOption.articleid !== currentArticle?.articleid) {
                        setArticle(matchingOption);
                    }
                    setFilter(articles.filter(a => a.isActif));
                } else {
                    setSearch(data.optionText);
                }
            }
        }}
        defaultValue={currentArticle && currentArticle.displayName ? currentArticle.displayName : undefined}
        defaultSelectedOptions={currentArticle && currentArticle.articleid ? [currentArticle.articleid] : undefined}
    >
        {Search ? (
            <Option key="freeform" text={Search}>
                Search for "{Search}"
            </Option>
        ) : null}
        {Filter.map((p) => (
            <Option key={p.articleid} value={p.articleid !== null ? p.articleid : ""}>{p.displayName !== null ? p.displayName : "-- ? --"}</Option>
        ))}
    </Combobox>;
};